import { SxProps, Theme } from '@mui/material';

export const pageContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '0 24px 0 24px',
  width: '931px',
  height: '852px',
  boxSizing: 'border-box',
  backgroundColor: '#F9FAFB'
};

export const cardSx = {
  background: '#FFFFFF',
  border: '1px solid #E5E7EB',
  borderRadius: '14px',
  px: '21px',
  py: '21px',
};

export const fieldSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  width: '841px'
} as SxProps<Theme>;

export const twoColRowSx = {
  display: 'flex',
  gap: '16px',
  width: '100%'
} as SxProps<Theme>;

export const buttonRowSx = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
  mt: 2,
} as SxProps<Theme>;

export const breadcrumbRowSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 6,
  width: '883px',
  height: '24px'
} as SxProps<Theme>;

export const breadcrumbLabelSx = {
  position: 'absolute',
  width: '83px',
  height: '24px',
  left: '1px',
  top: '-0.5px',
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  color: '#9CA3AF'
} as SxProps<Theme>;

export const pageTitleSx = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: '30px',
  color: '#111827'
} as SxProps<Theme>;

export const labelSx = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '20px',
  color: '#374151'
} as SxProps<Theme>;

export const inputBoxSx = {
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  padding: '10px 12px',
  width: '841px',
  height: '41.5px',
  border: '1px solid #E5E7EB',
  borderRadius: '10px'
} as SxProps<Theme>;

export const inputTwoColSx = {
  display: 'flex',
  gap: '16px',
  width: '841px'
} as SxProps<Theme>;

export const mapCanvasSx = {
  boxSizing: 'border-box',
  width: '841px',
  height: '220px',
  backgroundColor: '#F3F4F6',
  border: '1px solid #E5E7EB',
  borderRadius: '14px',
  position: 'relative',
  cursor: 'crosshair',
  overflow: 'hidden'
} as SxProps<Theme>;

export const saveButtonSx = {
  width: '70.35px',
  height: '39.5px',
  backgroundColor: '#39A9B1',
  color: '#FFFFFF',
  borderRadius: '10px',
  textTransform: 'none',
  fontWeight: 600
} as SxProps<Theme>;

export const cancelButtonSx = {
  width: '84.49px',
  height: '41.5px',
  border: '1px solid #E5E7EB',
  borderRadius: '10px',
  textTransform: 'none'
} as SxProps<Theme>;

export const jurisdictionCardSx = {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '21px',
  gap: '12px',
  width: '883px',
  height: '449px',
  background: '#FFFFFF',
  border: '1px solid #E5E7EB',
  borderRadius: '14px',
  opacity: 1,
  transform: 'rotate(0deg)'
} as SxProps<Theme>;

export const jurisdictionTitleSx = {
  position: 'absolute',
  width: '79px',
  height: '21px',
  left: 0,
  top: 0,
  fontFamily: 'Inter, Arial, sans-serif',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '21px',
  letterSpacing: '-0.15px',
  color: '#111827'
} as SxProps<Theme>;


export const drawControlsSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  width: '238.1328125px',
  height: '40px',
  paddingLeft: '4px',
  paddingRight: '4px',
  borderRadius: '10px',
  border: '1px solid #E5E7EB',
  opacity: 1,
  boxSizing: 'border-box',
  backgroundColor: '#F9FAFB',
  position: 'relative'
} as SxProps<Theme>;

export const drawButtonSx = {
  boxSizing: 'border-box',
  width: '109.5234375px',
  height: '30px',
  background: 'transparent',
  border: 'none',
  boxShadow: 'none',
  borderRadius: '8px',
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  color: '#6B7280',
  textTransform: 'none',
  letterSpacing: '0px'
} as SxProps<Theme>;

export const selectDistrictSx = {
  // KAN-133: match drawButtonSx.width so the sliding indicator (also 109.5234375px)
  // aligns precisely with this slot. Previously 110.61px caused a sub-pixel overhang.
  width: '109.5234375px',
  height: '30px',
  borderRadius: '8px',
  color: '#6B7280',
  background: 'transparent',
  border: 'none'
} as SxProps<Theme>;

export const clearButtonSx = {
  width: '56.4296875px',
  height: '30px',
  border: '1px solid #E5E7EB',
  borderWidth: '1px',
  borderRadius: '10px',
  fontSize: '12px',
  color: '#374151',
  opacity: 1,
  transform: 'rotate(0deg)',
  boxSizing: 'border-box'
} as SxProps<Theme>;

export const mapHelperRowSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '841px'
} as SxProps<Theme>;

export const toggleButtonBaseSx = {
  boxSizing: 'border-box',
  borderRadius: '8px',
  padding: 0,
  minWidth: 'unset',
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  textAlign: 'center',
  color: '#6B7280',
  background: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  zIndex: 1,
  textTransform: 'none',
  letterSpacing: '0px',
  '&.Mui-selected': {
    // keep the button visually transparent so the sliding indicator shows beneath,
    // but enforce the selected typography and text color per spec
    background: 'transparent',
    color: '#111827',
    fontWeight: 500,
    fontFamily: 'Inter, Arial, sans-serif',
    textTransform: 'none',
    letterSpacing: '0px'
  }
} as SxProps<Theme>;

export const slidingIndicatorSx = {
  position: 'absolute',
  top: '5px',
  left: '4px',
  width: '109.5234375px',
  height: '30px',
  background: '#FFFFFF',
  border: '1px solid #E5E7EB',
  boxShadow: '0px 1px 3px rgba(0,0,0,0.1), 0px 1px 2px -1px rgba(0,0,0,0.1)',
  borderRadius: '8px',
  transition: 'left 180ms ease',
  zIndex: 0
} as SxProps<Theme>;

export const drawHelperTitleSx = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0px',
  color: '#6B7280'
} as SxProps<Theme>;

export const drawHelperActionSx = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '16px',
  letterSpacing: '0px',
  color: '#6B7280',
  mt: '6px'
} as SxProps<Theme>;

export const textSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '-0.08px',
};

export const clickTextSx = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '16px',
  color: '#6B7280'
} as SxProps<Theme>;

// Station Details section tokens
export const stationDetailsCardSx = {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '21px 21px 1px',
  gap: '16px',
  width: '883px',
  height: '229px',
  background: '#FFFFFF',
  border: '1px solid #E5E7EB',
  borderRadius: '14px'
} as SxProps<Theme>;

export const stationDetailsTitleSx = {
  position: 'absolute',
  width: '97px',
  height: '21px',
  left: 0,
  top: 0,
  fontFamily: 'Inter, Arial, sans-serif',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '21px',
  letterSpacing: '-0.15px',
  color: '#111827'
} as SxProps<Theme>;

export const stationFieldContainerSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '841px'
} as SxProps<Theme>;

export const stationInputSx = {
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  padding: '10px 12px',
  width: '841px',
  height: '41.5px',
  border: '1px solid #E5E7EB',
  borderRadius: '10px'
} as SxProps<Theme>;

export const twoColFieldSx = {
  display: 'flex',
  gap: '16px',
  width: '841px'
} as SxProps<Theme>;

export const inputHalfSx = {
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  padding: '10px 12px',
  width: '412.5px',
  height: '41.5px',
  border: '1px solid #E5E7EB',
  borderRadius: '10px'
} as SxProps<Theme>;

export const helperPlaceholderSx = {
  color: 'rgba(17, 24, 39, 0.5)'
} as SxProps<Theme>;


// KAN-133: style MUI's outlined-input slots instead of the TextField root.
// Putting border/height/padding on the root double-bordered the Autocomplete
// (on top of MUI's own notched-outline fieldset) and left the input text
// vertically off-centre. Dimensions match the other station fields so the
// district field lines up with the rest of the form.
export const dropdownSx: SxProps<Theme> = {
  width: '841px',
  opacity: 1,
  '& .MuiOutlinedInput-root': {
    height: '41.5px',
    borderRadius: '10px',
    padding: '0 12px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E5E7EB',
  },
  '& .MuiOutlinedInput-input': {
    padding: 0,
  },
};